import React from "react";
import styles from "./css/MobileMenu.module.css";
import NavMenu from "./NavMenu";

export default function MobileMenu({ onClose }) {
    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.menu} onClick={(e) => e.stopPropagation()}>
                {/* Botão para fechar o menu */}
                <button
                    className={styles.closeButton}
                    onClick={onClose}
                    aria-label="Fechar menu"
                >
                    &times;
                </button>

                {/* Reaproveita a navegação do desktop (mesmos links e
                    comportamento de scroll), com estilo vertical mobile.
                    onItemClick fecha o menu ao clicar em um link. */}
                <NavMenu variant="mobile" onItemClick={onClose} />
            </div>
        </div>
    );
}
